import { memo } from 'react';
import { RiVipCrownFill } from '@react-icons/all-files/ri/RiVipCrownFill';

interface IPremiumIcon{
  size?: number;
  props?: any;
}

export const PremiumIcon = memo<IPremiumIcon>(({ size, ...props }) => {
  return <RiVipCrownFill color="#dbbf1d" size={size} {...props} />;
});
